import { render, staticRenderFns } from "./OmzR_Result_Summary.vue?vue&type=template&id=99b40f0a"
import script from "./OmzR_Result_Summary.vue?vue&type=script&lang=js"
export * from "./OmzR_Result_Summary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports